import { render, staticRenderFns } from "./PermissionInformation.vue?vue&type=template&id=6e4c21c2"
import script from "./PermissionInformation.vue?vue&type=script&lang=js"
export * from "./PermissionInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports